import { render, staticRenderFns } from "./BingliList.vue?vue&type=template&id=0598c7ba&scoped=true"
import script from "./BingliList.vue?vue&type=script&lang=js"
export * from "./BingliList.vue?vue&type=script&lang=js"
import style0 from "./BingliList.vue?vue&type=style&index=0&id=0598c7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0598c7ba",
  null
  
)

export default component.exports